// extracted by mini-css-extract-plugin
module.exports = {"link":"docreader_link__FK9c2","icon":"docreader_icon__Vx8zN"};